import React from 'react';
import { Form, Row, Col, FormInstance, Divider, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import TagsManagement from '@components/TagsManagement';

export interface IdentifiersStepDataProps {
  devEui: string;
  appEui: string;
  description?: string;
  tags?: string[];
  appKey?: string;
  devAddr?: string;
  nwksKey?: string;
  appsKey?: string;
}

interface IdentifiersStepProps {
  form: FormInstance<IdentifiersStepDataProps>;
  renderItemLabel: (label: string) => JSX.Element;
  renderInputItem: (
    label: string,
    numSize?: number,
    validateNumSize?: boolean,
  ) => JSX.Element;
  activation?: 'OTAA' | 'ABP';
  encryption?: 'NS' | 'APP';
}

const IdentifiersStep = ({
  form,
  renderItemLabel,
  renderInputItem,
  activation,
  encryption,
}: IdentifiersStepProps) => {
  const { t } = useTranslation('lorawan');

  const formValues = Form.useWatch([], form);

  const isActivationOtaa = activation === 'OTAA';
  const isActivationAbp = activation === 'ABP';
  const isEncryptionNs = encryption === 'NS';

  return (
    <Form
      colon={false}
      form={form}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      scrollToFirstError
      layout="vertical"
    >
      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col span={24}>
          <Form.Item label={t('description')} name="description">
            <Input allowClear />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          {renderInputItem('devEui', 16, true)}
        </Col>
        {isActivationOtaa && (
          <>
            <Col xs={24} sm={12}>
              {renderInputItem('appEui', 16, true)}
            </Col>
          </>
        )}
        <Col span={isActivationOtaa ? 24 : 12}>
          <Form.Item label={renderItemLabel('tags')} name="tags">
            <TagsManagement
              tags={formValues?.tags ?? []}
              onChange={newTags => {
                form.setFieldValue('tags', newTags);
              }}
            />
          </Form.Item>
        </Col>

        <Divider orientation="left">{t('security')}</Divider>
        {isActivationOtaa && (
          <Col span={24}>{renderInputItem('appKey', 32, true)}</Col>
        )}
        {isActivationAbp && (
          <>
            <Col span={24}>{renderInputItem('devAddr', 8, true)}</Col>
            <Col span={24}>{renderInputItem('nwksKey', 32, true)}</Col>
            {isEncryptionNs && (
              <Col span={24}>{renderInputItem('appsKey', 32, true)}</Col>
            )}
          </>
        )}
      </Row>
    </Form>
  );
};

export default IdentifiersStep;
